import axios from 'axios';
import config from '../../../config';

const authClient = axios.create({
  baseURL: `${config.API_BASE_URL}/users`,
});

export function loginWithCredentials({ email, password }) {
  return authClient.post('/login', { email, password });
}
